var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"video",attrs:{"loop":"","autoplay":"","muted":"","id":"video-player"},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("@/assets/geometric_background_4k.mp4"),"type":"video/mp4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }